









































































































































































































































































































































import {Component, Vue} from "vue-property-decorator";
import TDSSpinner from "@/components/common/TDSSpinner.vue";
import TDSModal from "@/components/partials/TDSModal/TDSModal.vue";
import TDSButton from "@/components/common/TDSButton.vue";
import Inputfield from "@/components/partials/Inputfield.vue";
import {WEBHOOK_TYPES} from "@/interfaces/entities/WebhookUrl";

@Component({
    components: {TDSSpinner, TDSModal, TDSButton, Inputfield}
})
export default class Webhooks extends Vue {
    private webhooksModalOpen: boolean = false;
    private ratesModalOpen: boolean = false;
    private webhookType: string = "";
    private urlInput: string = "";
    private isSubmitting: boolean = false;
    private locked: boolean = false;
    private thresholdInputs: string[] = [""];
    private thresholdPresets: number[] = [60, 80, 95];
    private ratesError: string = "";
    private isSavingRates: boolean = false;

    get isMobile(): boolean {
        return this.$store.state.isMobile;
    }

    get balanceAlertUrl(): string {
        return this.$store.state.balanceAlertUrl || "";
    }
    get dataUsageThresholdUrl(): string {
        return this.$store.state.dataUsageThresholdUrl || "";
    }
    get dataUsageThresholdRates(): number[] {
        return this.$store.state.dataUsageThresholdRates || [];
    }
    get eSimStatusUrl(): string {
        return this.$store.state.eSimStatusUrl || "";
    }
    get customerRegistrationUrl(): string {
        return this.$store.state.customerRegistrationUrl || "";
    }
    get countryChangeUrl(): string {
        return this.$store.state.countryChangeUrl || "";
    }
    get balanceActivationUrl(): string {
        return this.$store.state.balanceActivationUrl || "";
    }

    async created() {
        for (const type of Object.keys(WEBHOOK_TYPES)) {
            await this.$store.dispatch("FETCH_APIWEBHOOK_URL", type );
        }
        await this.$store.dispatch("FETCH_DATA_USAGE_THRESHOLDS");
    }

    async submit() {
        if (this.locked || (this.urlInput && !(this.$refs.urlInput as Inputfield)?.submit())) return;
        this.isSubmitting = true;
        try {
            await this.$store.dispatch("SAVE_APIWEBHOOK_URL", {url: this.urlInput, type: WEBHOOK_TYPES[this.webhookType as keyof typeof WEBHOOK_TYPES]});
            await this.$store.dispatch("FETCH_APIWEBHOOK_URL", this.webhookType);
            this.locked = true;
        } catch(e) {
            console.error(`Error while saving Webhook for ${this.webhookType}:`, e);
        } finally {
            this.isSubmitting = false;
        }

    }

    webhookI18nKey(value: string): string {
        if (value === "BALANCE_ALERT") return "lowBalanceAlert";
        if (value === "DATA_USAGE_THRESHOLD") return "dataConsumptionHook";
        return this.enumToCamelCase(value);
    }

    enumToCamelCase(value: string) {
        let newString: string = "";
        value.split("_").forEach((word: string, index: number) => {
            if(index === 0) newString = word.toLowerCase();
            else newString += word.substr(0,1) + word.substring(1).toLowerCase();
        });
        return newString;
    }

    openModal(type: string) {
        if(type === "BALANCE_ALERT") this.urlInput = this.balanceAlertUrl;
        if(type === "DATA_USAGE_THRESHOLD") this.urlInput = this.dataUsageThresholdUrl;
        if(type === "ESIM_STATUS") this.urlInput = this.eSimStatusUrl;
        if(type === "BALANCE_ACTIVATION") this.urlInput = this.balanceActivationUrl;
        this.webhookType = type;
        this.webhooksModalOpen = true;
    }

    openRatesModal() {
        if (!this.dataUsageThresholdUrl) return;
        this.thresholdInputs = this.dataUsageThresholdRates.length > 0
            ? this.dataUsageThresholdRates.map((rate: number) => String(Math.round(rate * 100)))
            : [""];
        this.ratesError = "";
        this.ratesModalOpen = true;
    }

    closeRatesModal() {
        this.ratesModalOpen = false;
        this.thresholdInputs = [""];
        this.ratesError = "";
    }

    addThresholdInput() {
        if (this.thresholdInputs.length >= 3) {
            this.ratesError = this.$t("apiDashboard.webhooks.modal.dataConsumptionHook.rates.maxReached").toString();
            return;
        }
        this.thresholdInputs.push("");
    }

    removeThresholdInput(index: number) {
        this.$nextTick(() => {
            this.thresholdInputs.splice(index, 1);
            if (this.thresholdInputs.length === 0) this.thresholdInputs = [""];
            this.ratesError = "";
        });
    }

    addPreset(preset: number) {
        if (this.isPresetDisabled(preset)) return;
        const presetStr = String(preset);
        if (this.thresholdInputs.includes(presetStr)) return;
        const emptyIndex = this.thresholdInputs.findIndex((value: string) => !value.trim());
        if (emptyIndex >= 0) {
            this.$set(this.thresholdInputs, emptyIndex, presetStr);
        } else if (this.thresholdInputs.length < 3) {
            this.thresholdInputs.push(presetStr);
        }
        this.ratesError = "";
    }

    isPresetDisabled(preset: number): boolean {
        const presetStr = String(preset);
        if (this.thresholdInputs.includes(presetStr)) return true;
        if (this.thresholdInputs.length < 3) return false;
        return !this.thresholdInputs.some((value: string) => !value.trim());
    }

    validateThresholdInput(value: string): boolean {
        const trimmed = value.trim();
        if (!trimmed) return true;
        const num = Number(trimmed);
        return Number.isInteger(num) && num >= 1 && num <= 100;
    }

    parseThresholdRates(): number[] | null {
        const values = this.thresholdInputs
            .map((value: string) => value.trim())
            .filter((value: string) => value.length > 0)
            .map((value: string) => Number(value));

        if (values.length === 0) return [];

        if (values.some((value: number) => !Number.isInteger(value) || value < 1 || value > 100)) {
            this.ratesError = this.$t("apiDashboard.webhooks.modal.dataConsumptionHook.rates.invalidRange").toString();
            return null;
        }
        if (new Set(values).size !== values.length) {
            this.ratesError = this.$t("apiDashboard.webhooks.modal.dataConsumptionHook.rates.duplicate").toString();
            return null;
        }
        if (values.length > 3) {
            this.ratesError = this.$t("apiDashboard.webhooks.modal.dataConsumptionHook.rates.maxReached").toString();
            return null;
        }

        return values.sort((a: number, b: number) => a - b).map((value: number) => value / 100);
    }

    async submitRates() {
        const rates = this.parseThresholdRates();
        if (rates === null) return;

        this.isSavingRates = true;
        try {
            await this.$store.dispatch("SAVE_DATA_USAGE_THRESHOLDS", rates);
            await this.$store.dispatch("FETCH_DATA_USAGE_THRESHOLDS");
            this.closeRatesModal();
        } catch (e) {
            const err = e as { response?: { status?: number } };
            if (err?.response?.status === 400) {
                this.$toastr.error(this.$t("apiDashboard.webhooks.modal.dataConsumptionHook.rates.missingUrl").toString());
            } else {
                this.$toastr.error(this.$t("apiDashboard.webhooks.modal.dataConsumptionHook.rates.saveFailed").toString());
            }
        } finally {
            this.isSavingRates = false;
        }
    }

    async clearAllRates() {
        this.isSavingRates = true;
        try {
            await this.$store.dispatch("SAVE_DATA_USAGE_THRESHOLDS", []);
            await this.$store.dispatch("FETCH_DATA_USAGE_THRESHOLDS");
            this.closeRatesModal();
        } catch (e) {
            const err = e as { response?: { status?: number } };
            if (err?.response?.status === 400) {
                this.$toastr.error(this.$t("apiDashboard.webhooks.modal.dataConsumptionHook.rates.missingUrl").toString());
            } else {
                this.$toastr.error(this.$t("apiDashboard.webhooks.modal.dataConsumptionHook.rates.saveFailed").toString());
            }
        } finally {
            this.isSavingRates = false;
        }
    }

    close() {
        this.webhooksModalOpen = false;
        this.urlInput = "";
    }
}
